import { createActions, createReducer } from 'reduxsauce';

export const STORAGE_KEY = 'cb:wizardDraft:v1'; // keep key; we migrate in saga

export const INITIAL_STATE = {
  // where the user is in the flow
  step: 1,

  // single flat "draft" object (easy to merge & send later)
  draft: {
    // Page 1/2 examples
    customerType: '', // e.g. "Premium Members" | "Followers" | ...
    itemType: '', // 'individual' | 'category' | 'all' (or your friendly labels)

    // Page 3
    offerImpact: '', // 'steady_growth' | 'quick_boost' | 'maximum_impact'

    // Page 4 (Recommended)
    suggestedDiscountType: '', // 'percentage' | 'dollar' | 'points'
    suggestedDiscountValue: '',

    // Page 5 (Design)
    title: '',
    description: '',
    couponType: 'percentage', // 'percentage' | 'dollar' | 'points'
    discountValue: '',
    heroImage: {
      // persisted locally
      dataUrl: null, // base64 for refresh survival
      fileName: null,
      mime: null,
      s3Id: 0, // filled after upload (if you upload before submit)
      url: null, // final CDN/S3 url (if already uploaded)
    },

    // Page 6 (Advanced)
    expiryType: 'date', // 'date' | 'quantity'
    expiryDate: null, // Date or ISO string
    totalQuantity: null,
    perUserLimitType: 'unlimited', // 'unlimited' | 'oneTime' | 'multiple'
    perUserLimitCount: null,
    redemptionType: 'manual', // 'manual' | 'auto'
    redeemableWithPoints: false,
    terms: '',
    reservationHours: null, // your time-range structure
    customerTypeMulti: [], // ← if you use multi-select segments (array)
  },

  // set true after we loaded from localStorage
  rehydrated: false,
};

const { Types, Creators } = createActions(
  {
    setStep: ['step'],
    updateDraft: ['patch'], // shallow merge for any shape
    attachHeroImage: ['imagePayload'], // { dataUrl, fileName, mime, url?, s3Id? }
    clearHeroImage: [],

    // persistence
    rehydrateFromStorage: [],
    rehydrateDone: ['payload'],
    resetWizard: [],
  },
  { prefix: 'cb/wizard/' },
);

export const types = Types;
export const actions = Creators;

/* Reducer */
const setStep = (state, { step }) => ({ ...state, step });

const updateDraft = (state, { patch }) => ({
  ...state,
  draft: { ...state.draft, ...patch },
});

const attachHeroImage = (state, { imagePayload }) => ({
  ...state,
  draft: {
    ...state.draft,
    heroImage: { ...state.draft.heroImage, ...imagePayload },
  },
});

const clearHeroImage = state => ({
  ...state,
  draft: {
    ...state.draft,
    heroImage: {
      dataUrl: null,
      fileName: null,
      mime: null,
      s3Id: 0,
      url: null,
    },
  },
});

const rehydrateDone = (state, { payload }) => ({
  ...(payload || state),
  rehydrated: true,
});

const resetWizard = _ => INITIAL_STATE;

export default createReducer(INITIAL_STATE, {
  [Types.SET_STEP]: setStep,
  [Types.UPDATE_DRAFT]: updateDraft,
  [Types.ATTACH_HERO_IMAGE]: attachHeroImage,
  [Types.CLEAR_HERO_IMAGE]: clearHeroImage,
  [Types.REHYDRATE_DONE]: rehydrateDone,
  [Types.RESET_WIZARD]: resetWizard,
});
